/* eslint-disable arrow-body-style */
import config from '@/util/config';
import http from '@/util/http';

const actionFn = (api, params, options = {}) => {
    // api地址处理
    const server = options.server && config[options.server] ? config[options.server] : undefined;
    const tempApi = server ? `${server}${api}` : api;

    return new Promise((resolve, reject) => {
        http.get(tempApi, params, options).then((res) => {
            if (res) {
                resolve(res.data);
            }
        }, (err) => {
            reject(err);
        });
    });
};

export default actionFn;



// WEBPACK FOOTER //
// ./src/store/actionFn.js